import { render, staticRenderFns } from "./BlockArchiveItem.vue?vue&type=template&id=23f1a86c&scoped=true&"
import script from "./BlockArchiveItem.vue?vue&type=script&lang=ts&"
export * from "./BlockArchiveItem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockArchiveItem.vue?vue&type=style&index=0&id=23f1a86c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1a86c",
  null
  
)

export default component.exports